// src/rapportAdminEdit.js
// ══════════════════════════════════════════════════════════════════════════
// Modification d'un rapport de ménage par la direction (SecRapports › « Modifier »).
// Logique pure, sans React : fusionne ce que renvoie RapportModal (r) avec les
// métadonnées d'origine du rapport (orig).
//
// Règles (v240) :
//  - auteur (sid), date du ménage, id, tâche, masquages et contrôle : TOUJOURS ceux d'origine ;
//  - état de soumission (sub) : celui d'origine, SAUF si l'admin clique « Soumettre » sur un
//    brouillon (fin=true et orig.sub vide) → le rapport passe en « soumis » (sub = horodatage).
//    Un rapport déjà soumis/contrôlé ne change jamais d'état, ni ne redescend en brouillon ;
//  - certification du salarié (engage / engageTs) : TOUJOURS celle d'origine. Une soumission
//    faite par l'admin ne vaut jamais attestation du salarié (décision de Claire, 19/10/2026).
// ══════════════════════════════════════════════════════════════════════════

export function fusionnerRapportAdmin(orig, r, fin, horodatage) {
  const o = orig || {};
  const soumission = fin === true && !o.sub;
  const merged = {
    ...r,
    id: o.id,
    sid: o.sid,
    tid: o.tid,
    date: o.date,
    sub: soumission ? (r && r.sub) || horodatage : o.sub,
    hidAdmin: o.hidAdmin,
    hidClient: o.hidClient,
    ctrlId: o.ctrlId, ctrlVerdict: o.ctrlVerdict, ctrlAt: o.ctrlAt,
    engage: o.engage,
    engageTs: o.engageTs,
  };
  if (merged.engage === undefined) delete merged.engage;
  if (merged.engageTs === undefined) delete merged.engageTs;
  return merged;
}
